<template>
  <div :style="{ backgroundColor: backgroundColor }">
    <img :src="icon" height="auto" :alt="title" v-if="icon" style="max-width: 70px;" />
    <div :style="{ fontSize: fontSize, fontWeight: fontWeight, color: color }">
      {{ title }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'LayoutBlockHead',
  props: {
    backgroundColor: {
      type: String,
      default: '#FAFAFB',
    },
    icon: {
      type: String,
    },
    fontSize: {
      type: String,
      default: '28px',
    },
    fontWeight: {
      type: Number,
      default: 600,
    },
    title: {
      type: String,
      required: true,
    },
    height: {
      type: Number,
      default: 48,
    },
    color: {
      type: String,
      default: '#06152F',
    },
  },
}
</script>
